import * as React from "react";
function SvgMehRollingEyesSolid(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={svgRef}
      {...props}
    >
      <path
        d="M12 2C6.476 2 2 6.476 2 12s4.476 10 10 10 10-4.476 10-10S17.524 2 12 2zm-6.452 8.71c0-.98.553-1.823 1.355-2.258-.028.104-.064.21-.064.322 0 .714.576 1.29 1.29 1.29.714 0 1.29-.576 1.29-1.29 0-.113-.036-.218-.064-.322a2.569 2.569 0 011.355 2.258 2.583 2.583 0 01-2.581 2.58 2.583 2.583 0 01-2.58-2.58zm9.033 7.096H9.419c-.854 0-.854-1.29 0-1.29h5.162c.854 0 .854 1.29 0 1.29zm1.29-4.516a2.583 2.583 0 01-2.58-2.58c0-.98.552-1.823 1.354-2.258-.028.104-.064.21-.064.322 0 .714.576 1.29 1.29 1.29.714 0 1.29-.576 1.29-1.29 0-.113-.036-.218-.064-.322a2.569 2.569 0 011.355 2.258 2.583 2.583 0 01-2.581 2.58z"
        fill="currentColor"
      />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgMehRollingEyesSolid);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
